import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {AccessService} from "../../utils/AccessService";
import {LocalStorage} from "../../utils/LocalStorage";
import { withTranslation } from 'react-i18next';

class UserTabsComponent extends Component {

    constructor(props) {
        super(props);

        this.handleGetUserModules = this.handleGetUserModules.bind(this);

        this.state = {
            modules: null
        };
    }

    handleGetUserModules(data) {
        this.setState({
            ...this.state,
            modules: data.modules
        });
    }

    getUserModules() {
        AccessService.GetUserModules(this.getUserId(), this.handleGetUserModules, null)
    }

    getUserId() {
        return LocalStorage.fetchUserId()
    }

    componentDidMount() {
        this.getUserModules();
    }

    renderModuleMarketing() {
        if (this.props.showModuleMarketing) {
            return (<li>
                <Link className="tab-button" to={`/user/${this.props.userId}/module/marketing`}>{this.getClientsMenuLabel()}</Link>
            </li>)
        }
    }

    renderSecurity() {
        const { t } = this.props;
        if (this.hasToShowSecurity()) {
            return (<li>
                <Link className="tab-button" to={`/user/${this.props.userId}/security`}>
                    {t('user_tabs.security')}
                </Link>
            </li>)
        }
    }

    renderProfile() {
        const { t } = this.props;
        return (<li>
            <Link className="tab-button" to={`/user/${this.props.userId}/profile`}>
                {t('user_tabs.profile')}
            </Link>
        </li>)
    }

    hasToShowSecurity() {
        if(!this.state.modules)
            return false;

        return this.state.modules.includes(AccessService.MODULE_ACCESS_CONFIGURATION)
    }

    renderModuleManageAccounts() {
        const { t } = this.props;
        if (this.props.showModuleManageAccounts) {
            return (<li>
                <Link className="tab-button" to={`/user/${this.props.userId}/module/manage-accounts`}>
                    {t('user_tabs.account_management')}
                </Link>
            </li>)
        }
    }

    getFinalActiveTab() {
        // Si la seleccionada es la de Administracion de Cuentas pero la de Gestión de cuentas está escondida, cambia el
        // activeTab
        if (this.props.activeTab === "-fourth") {
            if(!this.props.showModuleMarketing && this.hasToShowSecurity())
                return "-third"
            if(this.props.showModuleMarketing && !this.hasToShowSecurity())
                return "-third"
            if(!this.props.showModuleMarketing && !this.hasToShowSecurity())
                return "-second"
        }
        if (this.props.activeTab === "-third") {
            if(!this.hasToShowSecurity())
                return "-second"
        }
        return this.props.activeTab;
    }

    getAlertsMenuLabel() {
        const { t } = this.props;
        return this.editingLoggedUser() ? t('user_tabs.my_alerts') : t('user_tabs.alerts');
    }

    getClientsMenuLabel() {
        const { t } = this.props;
        return t('user_tabs.assigned_clients');
        //return this.editingLoggedUser() ? "Mis clientes" : "Clientes";
    }

    editingLoggedUser() {
        return this.props.userId !== undefined && LocalStorage.fetchUserId() === this.props.userId.toString()
    }

    render() {
        if (!this.state.modules)
            return "";

        return (
            <div className="filters">
                <ul className={`tabs ${this.getFinalActiveTab()}`}>
                    <li>
                        <Link className="tab-button" to={`/user/${this.props.userId}`}>{this.getAlertsMenuLabel()}</Link>
                    </li>
                    {this.renderModuleMarketing()}
                    {this.renderSecurity()}
                    {this.renderModuleManageAccounts()}
                    {this.renderProfile()}
                </ul>
            </div>
        )
    }
}

export const UserTabs = withTranslation()(UserTabsComponent);

